// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1svZs","selected":"styles_selected__1ZDjO"};